import isNil from 'lodash/isNil';
import {requiredMessage} from 'utils/const';

// Validates that a model has the given properties
export default function (model, requiredProps) {
  const errors = {};
  requiredProps.forEach(prop => {
    if ((isNil(model[prop]) ? '' : model[prop]) === '') {
      errors[prop] = requiredMessage;
    }
  });
  return errors;
}
